import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute,IndexRedirect, Link } from 'react-router';


class ThankYouEmail extends React.Component{

	goToOutro(){
		browserHistory.push(_assets.root + '/outro');
	}

	render(){
		return (<div className="quiz-outro-message">
					<h1>Thanks for being part of our raffle!<br/>We are getting back to you at March 3th.</h1>
					<button onClick={this.goToOutro}>Continue to outro</button>
				</div>);

	}
}

export default ThankYouEmail;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/thankYouEmail.js